import { Component, OnInit, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DataSource } from '@angular/cdk/collections';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { DocumentoService } from '../../services/documento.service'
import { AlertService } from '../../providers/alert.service'
@Component({
  selector: 'app-excluir-tipo',
  templateUrl: './excluir-tipo.component.html',
  styleUrls: ['./excluir-tipo.component.scss']
})
export class ExcluirTipoComponent implements OnInit {
	public loading = false;
	constructor(public dialogRef: MatDialogRef<ExcluirTipoComponent>,
		@Inject(MAT_DIALOG_DATA) public tipo: any,
		public tipo_service: DocumentoService,
		public alerts: AlertService) { }

	ngOnInit() {
	}

	excluir() {
		this.loading = true;
		this.tipo_service.deleteTipo(this.tipo['_id'])
			.then(res => {
				console.log(res);
				this.loading = false;
				this.alerts.openAlert('Tudo certo!', 'Excluído com sucesso');
				this.dialogRef.close(this.tipo);
			})
			.catch(error => {
				this.loading = false;
			})
	}

}
